import { parse, type ParseResult } from 'papaparse';

import { type UserFromCSV } from '../types';

const blankUser: UserFromCSV = {
    name: '',
    email: ''
};

const isClassHeaderRow = (headerRow): { hasHeaderRow: boolean; columnIndexes: Record<string, number> } => {
    const defaultIndexes = {
        name: 0,
        email: 1
    };

    const columnIndexes: Record<string, undefined | number> = {
        name: undefined,
        email: undefined
    };

    const acceptedUsernameHeaders = ['name', 'username'];
    const acceptedEmailHeaders = ['email', 'e-mail', 'email address', 'email_address'];

    // If more than one of any column matches, only the last will be accepted
    headerRow.forEach((key: string, index: number) => {
        if (typeof key === 'string') {
            if (acceptedUsernameHeaders.includes(key.trim().toLowerCase())) {
                columnIndexes.name = index;
            }
            if (acceptedEmailHeaders.includes(key.trim().toLowerCase()) && !key.trim().toLowerCase().includes('@')) {
                columnIndexes.email = index;
            }
        }
    });

    const hasHeaderRow = !Object.values(columnIndexes).includes(undefined);

    // @ts-ignore - hasHeaderRow conditional will skip this return if any indexes remain undefined
    if (hasHeaderRow) return { hasHeaderRow, columnIndexes };

    return { hasHeaderRow, columnIndexes: defaultIndexes };
};

export const parseUsersCsv = (csvText: string): UserFromCSV[] => {
    const parsedHeaderRow: ParseResult<string> = parse(csvText, { header: false, preview: 1, skipEmptyLines: 'greedy' });

    if (parsedHeaderRow.data.length === 0) return [{ ...blankUser }];

    const { hasHeaderRow, columnIndexes } = isClassHeaderRow(parsedHeaderRow.data[0]);

    // Parse to array of arrays (when config property header: true, parse returns array of keyed objects)
    // We are avoiding that to enforce uniformity in the headers / keys of the returned object and to allow us to pick from multiple columns
    const { data }: ParseResult<string> = parse(csvText, { header: false, skipEmptyLines: 'greedy' });

    if (hasHeaderRow) data.shift(); // pop header row from data

    // Translate [[]] to Admin[]
    const users: UserFromCSV[] = [];
    data.forEach((adminData) => {
        const newUser = {
            name: adminData[columnIndexes.name]?.trim(),
            email: adminData[columnIndexes.email]?.trim()
        };
        users.push(newUser);
    });

    return users;
};
